import axios from "axios";
import { BASE_URL } from "src/constants/enviroments";

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

export default api;
